/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Insert any custom theme js here...
function showSetions(){
    $('.hide-section').addClass('show');
    window.dispatchEvent(new Event('resize'));
}